import { render, staticRenderFns } from "./set-your-sights-on-the-marine-model-home.vue?vue&type=template&id=49f4bcae&"
import script from "./set-your-sights-on-the-marine-model-home.vue?vue&type=script&lang=js&"
export * from "./set-your-sights-on-the-marine-model-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports